import SubscriptionsEmpty from "@images/illustrations/subscriptions_2.svg"
import { BoxConsumableDetailsEntity } from "@modules/boxConsumable/entities/boxConsumableDetailsEntity"
import { BoxOfferInvitationEntity } from "@modules/boxOffer/entities/boxOfferInvitationEntity"
import { BoxSubscriptionDetailsEntity } from "@modules/boxSubscription/entities/boxSubscriptionDetailsEntity"
import { MemberOfferInvitationItem } from "@modules/members/memberOffers/components/memberOfferInvitationItem"
import { MemberOfferItem } from "@modules/members/memberOffers/components/memberOfferItem"
import { MemberOfferItemConsumableMenu } from "@modules/members/memberOffers/components/memberOfferItemConsumableMenu"
import { MemberOfferItemSubscriptionMenu } from "@modules/members/memberOffers/components/memberOfferItemSubscriptionMenu"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type Props = {
  memberId: string
  boxOfferInvitations?: BoxOfferInvitationEntity[]
  boxConsumablesDetails?: BoxConsumableDetailsEntity[]
  boxSubscriptionsDetails?: BoxSubscriptionDetailsEntity[]
  emptyText?: string
  setSubscriptionSelected?: React.Dispatch<React.SetStateAction<BoxSubscriptionDetailsEntity | null>>
  setIsOfferSupensionVisible?: React.Dispatch<React.SetStateAction<boolean>>
  setIsOfferDiscountVisible?: React.Dispatch<React.SetStateAction<boolean>>
  handleDeleteSubscription?: () => void
  handleShowCreditModal?: (consumableDetails: BoxConsumableDetailsEntity) => void
} & React.ComponentProps<"div">

export function MemberOffersList({
  memberId,
  boxOfferInvitations = [],
  boxConsumablesDetails = [],
  boxSubscriptionsDetails = [],
  emptyText,
  setSubscriptionSelected,
  setIsOfferSupensionVisible,
  setIsOfferDiscountVisible,
  handleDeleteSubscription,
  handleShowCreditModal,
  ...props
}: Props) {
  const defaultClassName = "flex flex-column gap-4 w-full"
  const defaultClassNameEmpty = "flex justify-content-center align-items-center gap-4 w-full mx-4 my-1"
  const theme = useTheme()

  const boxPurchasesSorted: (BoxConsumableDetailsEntity | BoxSubscriptionDetailsEntity | BoxOfferInvitationEntity)[] = [
    ...boxConsumablesDetails,
    ...boxSubscriptionsDetails,
    ...boxOfferInvitations,
  ].sort((a, b) => {
    const dateA = a instanceof BoxOfferInvitationEntity ? a.createdAt : a.creationDate
    const dateB = b instanceof BoxOfferInvitationEntity ? b.createdAt : b.creationDate
    return dateB.getTime() - dateA.getTime()
  })

  if (boxPurchasesSorted.length === 0) {
    return (
      <div className={props.className ?? defaultClassNameEmpty}>
        <HUText fontStyle="HS" color={theme.neutralColor700} className=" flex w-6">
          {emptyText}
        </HUText>
        <div
          className="flex bg-contain bg-center bg-no-repeat w-6 h-10rem h-4"
          style={{ backgroundImage: `url(${SubscriptionsEmpty})` }}
        ></div>
      </div>
    )
  }

  return (
    <div className={props.className ?? defaultClassName}>
      {boxPurchasesSorted.map((item) => {
        if (
          item instanceof BoxSubscriptionDetailsEntity &&
          setSubscriptionSelected &&
          setIsOfferSupensionVisible &&
          setIsOfferDiscountVisible &&
          handleDeleteSubscription
        ) {
          return (
            <MemberOfferItem
              item={item}
              key={item.id}
              menuActions={
                <MemberOfferItemSubscriptionMenu
                  subscriptionDetails={item}
                  setSubscriptionSelected={setSubscriptionSelected}
                  setIsOfferSupensionVisible={setIsOfferSupensionVisible}
                  setIsOfferDiscountVisible={setIsOfferDiscountVisible}
                  handleDeleteSubscription={handleDeleteSubscription}
                />
              }
            />
          )
        } else if (item instanceof BoxConsumableDetailsEntity && handleShowCreditModal) {
          return (
            <MemberOfferItem
              item={item}
              key={item.id}
              menuActions={
                <MemberOfferItemConsumableMenu
                  memberId={memberId}
                  consumableDetails={item}
                  handleShowCreditModal={handleShowCreditModal}
                />
              }
            />
          )
        } else if (item instanceof BoxOfferInvitationEntity) {
          return <MemberOfferInvitationItem item={item} key={item.id} />
        }
      })}
    </div>
  )
}
